module.exports = __webpack_public_path__ + "static/img/close-0.a4870ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/close-0.png
// module id = cdUI
// module chunks = 1